import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../../../hooks';
import { Input as DSInput } from '../../../Input/Input';
import { useEndIcon, useOnBlur, useOnChange, useOnFocus, useOnMouseDown, useOnEndIconClick } from './hooks';
import './Input.scss';
export const Input = ({ placeholder, fetching, loading, onSearch, setFocused, setValue, value, inputTestId, mask, inputRef, disabled, onClear, }) => {
    const className = useClassName({ name: 'auto-complete-input', prefixed: true }, (loading || fetching) && 'loading');
    const endIcon = useEndIcon({ fetching, loading, value, onClear });
    const onChange = useOnChange({ mask, onSearch, value, setValue });
    const onFocus = useOnFocus({ setFocused });
    const onBlur = useOnBlur({ setFocused });
    const onMouseDown = useOnMouseDown();
    const onEndIconClick = useOnEndIconClick({ onClear, setValue });
    return (_jsx("div", { className: className, children: _jsx(DSInput, { disabled: disabled, inputRef: inputRef, onMouseDown: onMouseDown, testId: inputTestId, onFocus: onFocus, endIcon: endIcon, onEndIconClick: onEndIconClick, onBlur: onBlur, value: value, onChange: onChange, placeholder: placeholder }) }));
};
